import React from "react"
import { Form } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import FormButtons from "./FormButtons"

export default function SimpleForm({ title, onSave, onCancel, saveText, cancelText, running, children }) {

  return (
    <div className="simple-form max-width-700 mx-auto mb-20">
      <Form horizontal onSubmit={e => { e.preventDefault(); onSave() }}>

        { title && <h3 className='flex-row-simple items-center'>
          <FontAwesome name='arrow-circle-left' className='p-10 cursor-pointer'
            onClick={ onCancel } title='Back' />
          <span className='flex1 pl-10'>{ title }</span>
        </h3>}
        { title && <hr />}

        { children }

        <FormButtons onSave={ onSave } onCancel={ onCancel } 
          running={ running } saveText={ saveText } cancelText={ cancelText } />
      </Form>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/fragments/SimpleForm.js